import { ArrowForwardIos } from "@mui/icons-material";
import { Box } from "@mui/material";

function Breadcrumbs({ pageType }) {

const breadCrumbStyle = {
  color: "#cccccc",
  fontSize: "0.9rem",
  textDecoration: "underline",
};

const breadCrumbActiveStyle = {
  color: "#0288d1",
  fontSize: "0.9rem",
  textDecoration: "underline",
};


  return (
    <Box sx={{mb:1}}>
        <span style={breadCrumbStyle}>Promotion Automation Platform </span>{" "}
        <ArrowForwardIos color="info" style={{ marginRight: "0.5rem" }} />
        <span style={breadCrumbActiveStyle}>{pageType}</span>
    </Box>
  );
}
export default Breadcrumbs;
